import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { SupportModal } from '@/modules/common';

/**
 * This component represents the planner error state.
 * Shown when the backend returns an error while loading planner data.
 */
export const PlannerErrorState = ({ onRefresh }: { onRefresh: () => void }) => {
  const { t } = useTranslation(['authenticated.planner', 'common']);

  return (
    <div className="absolute top-[6.2rem] py-[22px] pl-48 pr-4">
      <div className="mb-0.5 text-sm font-medium">{t('errorState.title')}</div>
      <div className="mb-3 text-xs text-muted-foreground">{t('errorState.description')}</div>
      <div className="flex gap-2">
        <SupportModal>
          <Button variant="outline">{t('common:contactSupport')}</Button>
        </SupportModal>
        <Button variant="default" onClick={onRefresh}>
          <RefreshCw className="h-4 w-4" />
          {t('errorState.refresh')}
        </Button>
      </div>
    </div>
  );
};
